import { logger } from "@hopper-b2b/api";
import { ClientName } from "@hopper-b2b/types";
import { ActionButton } from "@hopper-b2b/ui-core";
import { getEnvVariables, useTapHandlers } from "@hopper-b2b/utilities";
import clsx from "clsx";
import { FloatingBox } from "../FloatingBox";
import "./styles.scss";

export interface MobileFloatingSectionButton {
  children: string | JSX.Element;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
}

export interface IMobileFloatingSectionProps {
  className?: string;
  primaryButton: MobileFloatingSectionButton;
  secondaryButton?: MobileFloatingSectionButton | null;
  description?: any;
  /** Datadog log prefix for Nubank WebView tap diagnostics (ATL-762). */
  primaryButtonTapLogName?: string;
}

export const MobileFloatingSection = (props: IMobileFloatingSectionProps) => {
  const { className } = props;

  const usePaper = getEnvVariables("clientName") === ClientName.HOPPER;

  return (
    <FloatingBox className={clsx(className, "mobile-floating-section")}>
      {usePaper ? (
        <div>
          <div>
            <MobileFloatingSectionContent {...props} />
          </div>
        </div>
      ) : (
        <MobileFloatingSectionContent {...props} />
      )}
    </FloatingBox>
  );
};

const MobileFloatingSectionContent = (props: IMobileFloatingSectionProps) => {
  const {
    description,
    primaryButton,
    secondaryButton,
    primaryButtonTapLogName,
  } = props;
  const usePrimaryTapHandlers = Boolean(primaryButtonTapLogName);
  const { onClick: onPrimaryTapClick, ...primaryTapHandlers } = useTapHandlers({
    onTap: primaryButton.onClick,
    disabled: primaryButton.disabled,
    logName: primaryButtonTapLogName,
    onLog: usePrimaryTapHandlers
      ? (level, message, meta) => logger()?.[level](message, meta)
      : undefined,
    recoverTapOnPointerCancel: usePrimaryTapHandlers,
  });

  const primaryActionButton = (
    <ActionButton
      className={clsx(
        "mobile-floating-section-wrapper",
        "primary-button-wrapper",
        primaryButton.wrapperClassName
      )}
      buttonClassName={clsx(
        "mobile-floating-section-button",
        "primary-button",
        primaryButton.className
      )}
      disabled={primaryButton.disabled}
      message={primaryButton.children}
      onClick={
        usePrimaryTapHandlers ? onPrimaryTapClick : primaryButton.onClick
      }
    />
  );

  return (
    <>
      {description ? (
        <div className="mobile-floating-section-description">{description}</div>
      ) : null}
      {secondaryButton ? (
        <ActionButton
          className={clsx(
            "mobile-floating-section-wrapper",
            "secondary-button-wrapper",
            secondaryButton.wrapperClassName
          )}
          buttonClassName={clsx(
            "mobile-floating-section-button",
            "secondary-button",
            secondaryButton.className
          )}
          defaultStyle="h4r-secondary"
          disabled={secondaryButton.disabled}
          message={secondaryButton.children}
          onClick={secondaryButton.onClick}
        />
      ) : null}
      {usePrimaryTapHandlers ? (
        <div {...primaryTapHandlers}>{primaryActionButton}</div>
      ) : (
        primaryActionButton
      )}
    </>
  );
};
